module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
   var type = connectionType?connectionType:'0';

    ; __append("\r\n<!-- 3 column layout  -->\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn(dashboardTitle))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function(crumb) {
            crumbCount++;
            if (crumbCount === count) {
                
    ; __append("\r\n                <li class=\"active\">")
    ; __append(escapeFn(crumb.name))
    ; __append("</li>\r\n                ")
    ;       } else { 
    ; __append("\r\n                <li><a href=\"")
    ; __append(escapeFn(crumb.route))
    ; __append("\" id=\"")
    ; __append(escapeFn(crumb.id))
    ; __append("\">")
    ; __append(escapeFn(crumb.name))
    ; __append("</a></li>\r\n                ")
    ; 
            }
        })
        
    ; __append("\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"connection row\">\r\n    <div class=\"col-md-6\" style=\"padding-right:40px;\">\r\n        <div class=\"row\" style=\"margin-bottom: 0; padding-bottom: 0;\">\r\n            <div id=\"connectionGeneral\"></div>\r\n        </div>\r\n        <div class=\"row\" style=\"margin-top: 0; padding-top: 0;\">\r\n            <div id=\"permissions\" style=\"padding-right: 30px;\"></div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div id=\"connectionDetails\"></div>\r\n        </div>\r\n    </div>\r\n   <div class=\"col-md-6\">\r\n       <div id=\"connectionActions\"></div>\r\n       <div id=\"connectionExtras\"></div>\r\n   </div>\r\n   \r\n</div>\r\n\r\n\r\n\r\n<div class=\"row\" id=\"actionsControlView\"></div>")
  }
  return __output;

}